/**
 * Supported Asymmetric Key algorithms
 * @enum
 */
export enum SignatureAlgorithm {
  Ed25519 = 'ed25519',
  Secp256K1 = 'secp256k1'
}
